/** Up-to-two-letter initials from a name, e.g. "Mum" → "M", "Op Mum" → "OM". */
export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
};

export const formatFullName = (
  firstName?: string | null,
  lastName?: string | null,
): string => [firstName, lastName].filter(Boolean).join(' ').trim();
